import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    testSetList: [],
    testSetEntryData: {},
  },
  getters: {
    testSetList: (state) => state.testSetList,
    testSetEntryData: (state) => state.testSetEntryData,
  },
  actions: {
    loadTestSetList(context) {
      return new Promise((resolve, reject) => {
        alice
          .listTestSet()
          .then((response) => {
            context.commit('setTestSetList', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createTestSet(context, { name, benchmarkId }) {
      return new Promise((resolve, reject) => {
        alice
          .createTestSet(name, benchmarkId)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteTestSet(context, { setId }) {
      return new Promise((resolve, reject) => {
        alice
          .deleteTestSet(setId)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadTestSetData(context, {
      setId, size, page, filter,
    }) {
      return new Promise((resolve, reject) => {
        let realPageNo = page - 1;
        if (realPageNo < 0) {
          realPageNo = 0;
        }
        alice
          .getTestSetEntryPage(setId, realPageNo, size, filter)
          .then((response) => {
            context.commit('setTestSetEntry', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createTestSetEntry(context, { setId, entryList }) {
      return new Promise((resolve, reject) => {
        alice
          .createTestSetEntry(setId, entryList)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateTestSetEntry(context, { setId, entryId, data }) {
      return new Promise((resolve, reject) => {
        alice
          .updateTestSetEntry(setId, entryId, data)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteTestSetEntry(context, { setId, entryId }) {
      return new Promise((resolve, reject) => {
        alice
          .deleteTestSetEntry(setId, entryId)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    setTestSetList(state, data) {
      Vue.set(state, 'testSetList', data);
    },
    setTestSetEntry(state, data) {
      Vue.set(state, 'testSetEntryData', data);
    },
  },
};
